module.exports = __webpack_public_path__ + "static/media/moment.ba0713ee.svg";